import React from "react";
import MasterModule from "../MasterModule";
import Brands from "./Brands";
import RawMaterials from "./RawMaterials";
import Category from "./Category";
import Products from "./Products";
import Warehouse from "../Erp/Warehouse";
import StockUpdate from "./StockUpdate";
import Suppliers from "./Suppliers";
import { ERP_AUTH, INVENTORY_AUTH } from "../../../config/authorizationConfig";

// Module configuration
const inventoryModules = [
  {
    name: "Brands",
    component: Brands,
    authConfig: INVENTORY_AUTH.MANAGE_BRANDS,
  },
  {
    name: "Raw Materials",
    component: RawMaterials,
    authConfig: INVENTORY_AUTH.MANAGE_RAW_MATERIALS,
  },
  {
    name: "Product Category",
    component: Category,
    authConfig: INVENTORY_AUTH.MANAGE_PRODUCT_CATEGORY,
  },
  {
    name: "Products",
    component: Products,
    authConfig: INVENTORY_AUTH.MANAGE_PRODUCTS,
  },
  {
    name: "Warehouse",
    component: Warehouse,
    authConfig: ERP_AUTH.MANAGE_WAREHOUSE,
  },

  {
    name: "Stock Levels",
    component: StockUpdate,
    authConfig: INVENTORY_AUTH.MANAGE_STOCK_LEVELS,
  },
  {
    name: "Suppliers",
    component: Suppliers,
    authConfig: INVENTORY_AUTH.MANAGE_SUPPLIERS,
  },
];

// API endpoints mapping
// Note: Stock Levels uses multiple endpoints (array) - MasterModule handles this automatically
const inventoryApiEndpoints = {
  Brands: "/brands/enabled",
  "Raw Materials": "/raw-materials",
  "Product Category": "/categories",
  Products: "/products",
  Warehouse: "/warehouses",

  "Stock Levels": [
    "/warehouse-stock/raw-materials",
    "/warehouse-stock/products",
  ],
  Suppliers: "/suppliers",
};

const InventoryMaster = () => {
  return (
    <MasterModule
      title="Inventory Modules"
      modules={inventoryModules}
      apiEndpoints={inventoryApiEndpoints}
      // Uses default getApiUrl from MasterModule (role-based URL selection)
    />
  );
};

export default InventoryMaster;
